import BigNumberController from './big-number-controller';

const BigNumberComponent: angular.IComponentOptions = {
  controller: BigNumberController,
  controllerAs: 'ctrl',
  bindings: {
    view: '=?setView',
    dataset: '<',
    chartID: '@id',
    onAction: '&',
    onEdit: '&',
    onRenderStart: '&',
    onRenderEnd: '&',
    chartOptions: '<',
    viewer: '<',
  },
  template: `
    <div
      class="editor-module editor-chart mode-object editor-multi big-number"
      ng-class="{'has-trend-label': ctrl.trendLabel().length > 0, 'is-phantom-mode': ctrl.isPhantomMode(), 'is-report-mode': ctrl.isReportMode() }"
      ng-if="ctrl.view && ctrl.data">

      <!-- Chart Wrapper Begins -->
      <div class="chart-wrapper" ng-class="{'no-border': ctrl.isEmptyStateInDesigner() }">

        <!-- Chart Content Begins -->
        <div class="chart-content" ng-if="!ctrl.isEmptyStateInDesigner()">
          <!-- Component Header Begins -->
          <div class="new-viz-actions" ng-if="!(ctrl.isDesignerMode() || ctrl.viewer === 'whiteLabel')">
            <copy-link-to-viz link="ctrl.renderInfo._vizReportRunLink">
              <button
                class="new-viz-action hide-2 hide-3 hide-4"
                uib-tooltip="Get Share Link"
                copy-to-clipboard
                clipboard-text="ctrl.getReportVizURL()"
                clipboard-success="ctrl.copySuccess()"
                clipboard-enabled="isClipboardEnabled">
                <svg-icon type="'copy-link'"></svg-icon>
              </button>
            </copy-link-to-viz>

            <button class="new-viz-action kebab-action">
              <kebab-menu targetable="true">
                <li menu-item="exp" ng-click="ctrl.linkTo($event, 'query')" ng-href="{{ ctrl.getReportQueryURL() }}" ng-if="!ctrl.viewer">View Query <span class="mode-show-embed-inline">in Mode</span></li>
                <li menu-item="exp" ng-click="ctrl.linkTo($event, 'data')" ng-href="{{ ctrl.getReportDataURL() }}">View Query Results <span class="mode-show-embed-inline">in Mode</span></li>
              </kebab-menu>
            </button>
          </div>
          <!-- Component Header Ends -->

          <!-- Big Number Chart Begins -->
          <div class="chart-big-number">
            <div class="chart-title clearfix" ng-if="ctrl.displayTitle(ctrl.chartTitle())">
              <in-place-edit
                text="ctrl.chartTitle()"
                alt-text="Click to add title"
                on-change="ctrl.updateChartTitle($text)"
                no-edit="ctrl.titleEditDisabled()"></in-place-edit>
            </div>
            <div class="chart-title chart-description clearfix" ng-if="ctrl.displayTitle(ctrl.chartDescription())">
              <in-place-edit
                text="ctrl.chartDescription()"
                alt-text="Click to add a description"
                on-change="ctrl.updateChartDescription($text)"
                no-edit="ctrl.titleEditDisabled()"></in-place-edit>
            </div>
            <div class="aggregate">
              <fillerbuster
                token="ctrl.token"
                font-size-max="48"
                font-size-min="0"
                font-name="ctrl.font()"
                content="ctrl.formattedAggregate()"></fillerbuster>
            </div>
            <div
              class="trend-with-palette trend-{{ctrl.trendDirection()}} color-scale-{{ctrl.colorScaleName()}}"
              style="color: {{ctrl.trendColorFromPalette()}}"
              ng-if="ctrl.trendAvailable()">
              <span class="trend-direction-icon"
                style="{{ ctrl.trendArrowStyle() }}"></span>
              <span class="trend-value">
                {{ ctrl.formattedChangeRate() }}
              </span>
              <span class="trend-label">
                {{ ctrl.trendLabel() }}
              </span>
            </div>
          </div>
          <!-- @Big Number Chart Ends -->


        </div>
        <!-- @Chart Content Ends -->

        <!-- Intermediary Messages Begins -->
        <div ng-if="ctrl.exceedsRowLimit()" class="more-text">
          This chart only shows the first {{ ctrl.getRowLimit() | number }} rows.
        </div>
        <div ng-if="ctrl.dataState('cancelled')" class="error-message">
          <i class="icon-warning-small error-icon"></i>
          <div class="message">This query was canceled</div>
          <div class="sub-message"></div>
        </div>
        <div ng-if="ctrl.isEmptyStateInDesigner()" class="error-message error-empty-message">
          <div class="hero">
            <i class="icon-abacus"></i>
          </div>
          <div class="message">
            <h2 class="heading">Looks like your results don't contain numerical data</h1>
            <h3 class="summary">To create a big number chart, make sure to use a data set that includes at least one numerical column</h3>
          </div>
        </div>
        <!-- @Intermediary Messages End -->

      </div>
      <!-- @Chart Wrapper -->

    </div>`,
};

export { BigNumberComponent };
